<template>
	<eg-modal
		height="300px"
		width="800px"
		:show="show"
		@close="$emit('close', false)"
		><p class="center" slot="header">
			<b>Insira o novo e-mail desejado para o fornecedor abaixo.</b>
		</p>
		<div slot="body">
			<div class="input-field">
				<eg-input
					:value="email"
					v-model="email"
					name="email"
					placeholder-text="E-mail*"
					:has-icon="true"
					background-color="#FFF"
					icon="fas fa-envelope"
					:rules="emailRules"
					@valid="emailRules.valid = $event"
				/>
			</div>
		</div>
		<div slot="footer">
			<button
				:disabled="!formValid"
				@click="validateForm"
				:class="`btn ${btnColor} darken-4`"
			>
				Atualizar E-mail
			</button>
		</div>
	</eg-modal>
</template>

<script>
import {updateInvitationEmail} from '@/services';
export default {
    name: 'updateInvitationEmail',
    data: () => ({
        email: '',
        emailRules: {
            name: 'E-mail',
            type: 'email',
            required: true,
            valid: true,
        },
    }),
    props: {
        show: Boolean,
        id: String,
        supplier: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    methods: {
        async validateForm() {
            if (this.formValid && this.email.trim() != '') {
                await this.updateInvitationEmail();
            }
        },
        async updateInvitationEmail() {
            const data = {
                competition_id: this.id,
                token: this.supplier.token,
                email: this.email,
            };
            await updateInvitationEmail(data);
            window.location.reload();
        },
    },
    watch: {
        show: function() {
            this.email = this.supplier.email;
        },
    },
    computed: {
        btnColor() {
            return this.formValid ? 'blue' : 'gray';
        },
        formValid() {
            return this.emailRules.valid ? true : false;
        },
    },
};
</script>

<style></style>
